import { tv, type VariantProps } from "tailwind-variants";

export const colorListVariant = tv({
  slots: {
    base: [
      "flex",
      "flex-col",
      "gap-5",
      "pb-8",
      "section-border",
      "last:border-0",
      "last:pb-0",
    ],
    header: ["flex", "flex-col", "gap-3", "max-w-166"],
    title: ["text-text-neutral-default"],
    description: ["text-text-neutral-soft"],
    inputGroup: ["flex", "items-center", "gap-5", "mt-5"],
    list: ["flex", "flex-col", "gap-1.5", "w-full"],
  },
  variants: {},
  defaultVariants: {},
});

export type ColorListVariantProps = VariantProps<typeof colorListVariant>;
export type ColorListReturnVariantProps = ReturnType<typeof colorListVariant>;
